<template>
  <l-rotated-marker
    :lat-lng="[marker.position.lat, marker.position.lng]"
    visible
    :draggable="false"
    @mouseover="emitMarkerOver"
    @mouseout="emitMarkerOut"
    :rotation-angle="(marker.icon.iconRotation ? marker.icon.iconRotation : 0)"
    ref="theMarker"
  >
    <l-icon
      :icon-anchor="marker.icon.iconAnchor"
      style="position: relative;"
      :tooltipAnchor="marker.icon.tooltipAnchor"
      :popupAnchor="marker.icon.popupAnchor"
      :icon-size="marker.icon.iconSize"
    >
      <div style="position: relative; width: 100%; height: 100%;">
        <img :src="marker.icon.iconUrl" v-if="marker.icon.iconUrl">
        <div v-else-if="marker.icon.iconType === 'marker-circle'" class="marker-circle" :style="'width: ' + marker.icon.iconSize[1] + 'px; height: ' + marker.icon.iconSize[1] + 'px; border-color: ' + marker.icon.iconColor">
          <span v-if="showMarkersText">{{marker.icon.iconText}}</span>
        </div>
        <div v-else-if="marker.icon.iconType === 'map-tag'" class="map-tag text-nowrap" :style="'background-color: ' + marker.icon.iconColor + '; ' + textContrastColor(marker.icon.iconColor.replace('#', '')) + '!important;'">
          <span class="icon-dynamic-mark" :style="'background: ' + (marker.icon.iconDynamic === 'true' ? '#0d0' : '#d00') + ';'" v-if="marker.icon.iconDynamic"></span>
          <span v-if="showMarkersText" class="text-nowrap">{{marker.icon.iconText}}</span>
          <span v-if="ecosystemModules.items.loadableBy" class="icon-load-mark" :style="'background: ' + (marker.icon.iconLoad === 'true' ? '#0d0' : '#fff') + ';'"><span v-if="!marker.icon.iconLoad" class="text-danger">×</span></span>
        </div>
        <span v-else>
          <span :style="'font-size: ' + marker.icon.iconSize[1] + 'px; line-height: 1'">
            <font-awesome-layers class="fa-1x" style="vertical-align: middle">
              <font-awesome-icon size="1x" :transform="(marker.icon.iconRotation && (marker.icon.iconRotation > 90 || marker.icon.iconRotation < -90) ? ' flip-v' : '')" :icon="marker.icon.iconType" style="filter: drop-shadow(0 0 1px rgba(255,255,255,1)) drop-shadow(0 2px 2px rgba(0,0,0,.3));" :color="marker.icon.iconColor" />
              <font-awesome-icon transform="shrink-10" color="#fff" icon="circle" v-if="marker.icon.iconDynamic" />
              <font-awesome-icon transform="shrink-12" icon="circle" :color="marker.icon.iconDynamic === 'true' ? '#0d0' : '#d00'" v-if="marker.icon.iconDynamic" />
              <span class="pin-text text-white" :style="'font-size: ' + marker.icon.iconSize[1] / 3.75 + 'px; line-height: ' + marker.icon.iconSize[1] / 3 * 1.5 + 'px; ' + textContrastColor(marker.icon.iconColor.replace('#', '')) + '!important; z-index: 10000 !important;'">{{marker.icon.iconText}}</span>
            </font-awesome-layers>
          </span>
        </span>
      </div>
    </l-icon>
    <l-popup v-if="marker.popup">

      <div v-if="marker.infoText.type === 'base'">
        <h5><translate>Base Information</translate></h5>
        <h6 v-if="marker.infoText.data.reference">{{marker.infoText.data.reference}}</h6>
        <p>{{marker.infoText.data.googlePlaceString}}</p>
        <div class="text-center">
          <b-button size="sm" @click="emitBase(marker.infoText); infoWinOpen = false" v-translate>
            Search Nearby
          </b-button>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'courier'">
        <user-card :user='marker.infoText.user' :withMap="false" :profilePicture="false" :withTitles="false" />
        <b-button size="sm" @click="emitCourier(marker.infoText.id)" v-if="marker.infoText.withPanel">
          Open Info Panel
        </b-button>
      </div>

      <div v-if="marker.infoText.type === 'gcm-courier'">
        <user-card :user="marker.infoText.data" :withMap="false" profilePictureSize="50px" :withTitles="false" />
        <div class="text-center p-1">
          <b-button size="sm" @click="emitCourier(marker.infoText); infoWinOpen = false" v-translate>
            Search Nearby
          </b-button>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'gcm-shipping'">
        <p v-if="marker.infoText.ids && !marker.infoText.isShared"><br>
          ID/s: <strong v-for="(id, index) in marker.infoText.ids" :key="index">
            <b-link :to="{name: 'ShippingsEdit', params: {id}}" target="_blank">{{ id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a><span v-if="(index + 1) < marker.infoText.ids.length">, </span>
          </strong>
        </p>
        <h6 v-else>
          <span v-translate><strong>Shared</strong> Shipment</span>
        </h6>
        <div v-html="marker.infoText.html"></div>
        <div v-if="marker.infoText.data.courier">
          <hr class="my-1">
          <user-card class="my-3" :user="marker.infoText.data.courier" :withMap="false" profilePictureSize="50px" :withTitles="false" />
        </div>
        <div>
          <div class="text-center">
            <b-button size="sm" variant="primary" @click="emitData(marker.infoText.data)" v-translate>
              View Detail
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'shipping'">
        <p v-if="marker.infoText.ids && !marker.infoText.isShared"><br>
          ID/s: <strong v-for="(id, index) in marker.infoText.ids" :key="index">
            <b-link :to="{name: 'ShippingsEdit', params: {id}}" target="_blank">{{ id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a><span v-if="(index + 1) < marker.infoText.ids.length">, </span>
          </strong>
        </p>
        <h6 v-else>
          <span v-translate><strong>Shared</strong> Shipment</span>
        </h6>
        <div v-html="marker.infoText.html"></div>
      </div>

      <div v-if="marker.infoText.type === 'collection'">
        <div v-html="marker.infoText.html"></div>
        <b-button variant="danger" size="sm" @click="emitRemoveFromCollection(marker.infoText.id); infoWinOpen = false" v-translate>
          Remove from Collection
        </b-button>
      </div>

      <div v-if="marker.infoText.type === 'cluster'">
        <div v-html="marker.infoText.html"></div>
        <div class="text-center">
          <form class="mb-2" @submit.prevent.stop="emitMoveToCluster(marker.infoText.id, clusterTo); infoWinOpen = false">
            <translate>Send to Cluster:</translate>
            <b-form-select v-model="clusterTo" required class="w-auto">
              <option v-for="(cluster, index) in clusters" :key="index" :value="cluster[0].cluster" :disabled="cluster[0].cluster === marker.infoText.cluster">
                {{ cluster[0].cluster }}
              </option>
            </b-form-select>
            <b-button variant="secondary" size="sm" type="submit" v-translate>
              Move!
            </b-button>
          </form>
          <b-button variant="primary" size="sm" @click="emitSelectCluster(marker.infoText.cluster); infoWinOpen = false" class="mb-2" v-translate>
            Select this Cluster
          </b-button><br>
          <b-button variant="danger" size="sm" @click="emitRemoveFromCollection(marker.infoText.id); infoWinOpen = false" v-translate>
            Remove from Collection
          </b-button>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'visit'">
        <shipping-visit :visit="marker.infoText.data" with-ids />
        <b-button v-show="marker.infoText.visited !== true && !marker.infoText.multi && marker.infoText.status !== 'FINISHED'" variant="danger" size="sm" @click.stop.prevent="emitDeleteFromTour(marker.infoText.id); infoWinOpen = false" v-translate>DELETE from this Tour</b-button>
      </div>

      <div v-if="marker.infoText.type === 'item'">
        <h3 v-if="ecosystemModules.items.label && marker.infoText.data.reference_code">
          <b-badge variant="dark">
            {{marker.infoText.data.reference_code}}
          </b-badge>
        </h3>
        <h3 v-else-if="ecosystemModules.items.label && !marker.infoText.data.reference_code">
          {{ecosystemModules.items.label}}
        </h3>
        <h3 v-else v-translate>
          Items
        </h3>
        <dynamic-info-text :template-html="ecosystemModules.items.templateInfoText || '<div>' + $gettext('No template') + '</div>'" :marker="marker" />
        <div v-if="marker.infoText.data.shippings && marker.infoText.data.shippings.length > 0">
          <hr>
          <h6 v-translate>In Shippings</h6>
          <div v-for="(shipping, index) in marker.infoText.data.shippings" :key="'in-shipping' + index">
            <b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{ shipping.id | uuid }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
            <b-button size="sm" variant="link" @click="emitData({...shipping, ...{cardType: 'shipping', normalize: true}})">
              <font-awesome-icon :icon="['far', 'eye']" />
            </b-button>
          </div>
          <hr>
        </div>
        <div v-else-if="marker.infoText.data.shipping && marker.infoText.data.shipping.id">
          <hr>
          <p>
            <h6 v-translate>In Shipping</h6>
            <b-link :to="{name: 'ShippingsEdit', params: {id: marker.infoText.data.shipping.id}}" target="_blank">{{ marker.infoText.data.shipping.id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(marker.infoText.data.shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </p>
          <div class="text-center">
            <b-button size="sm" variant="primary" @click="emitData({...marker.infoText.data.shipping, ...{cardType: 'shipping', normalize: true}})" v-translate>
              View Detail
            </b-button>
            <b-button size="sm" variant="dark" @click="$root.$emit('Items::TrackingHistory::show', marker.infoText.data)" v-translate>
              Tracking History
            </b-button>
          </div>
        </div>
        <div class="text-center" v-if="!marker.infoText.data.shipping || (marker.infoText.data.shippings && marker.infoText.data.shippings.length > 0)">
          <b-button size="sm" @click="emitCreateShippingFromItem(marker.infoText.data)" v-translate>
            Create Shipping
          </b-button>
          <b-button size="sm" variant="dark" @click="$root.$emit('Items::TrackingHistory::show', marker.infoText.data)" v-translate>
            Tracking History
          </b-button>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'item-navigate'">
        <h3 v-if="ecosystemModules.items.label && marker.infoText.data.reference_code">
          <b-badge variant="dark">
            {{marker.infoText.data.reference_code}}
          </b-badge>
        </h3>
        <h3 v-else-if="ecosystemModules.items.label && !marker.infoText.data.reference_code">
          {{ecosystemModules.items.label}}
        </h3>
        <h3 v-else v-translate>
          Items
        </h3>
        <dynamic-info-text :template-html="ecosystemModules.items.templateInfoText || '<div>' + $gettext('No template') + '</div>'" :marker="marker" />
        <div v-if="marker.infoText.data.shippings && marker.infoText.data.shippings.length > 0">
          <hr>
          <h6 v-translate>In Shippings</h6>
          <div v-for="(shipping, index) in marker.infoText.data.shippings" :key="'in-shipping' + index">
            <b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{ shipping.id | uuid }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
            <b-button size="sm" variant="link" @click="emitData({...shipping, ...{cardType: 'shipping', normalize: true}})">
              <font-awesome-icon :icon="['far', 'eye']" />
            </b-button>
          </div>
          <hr>
        </div>
        <div v-else-if="marker.infoText.data.shipping && marker.infoText.data.shipping.id">
          <hr>
          <p>
            <h6 v-translate>In Shipping</h6>
            <b-link :to="{name: 'ShippingsEdit', params: {id: marker.infoText.data.shipping.id}}" target="_blank">{{ marker.infoText.data.shipping.id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(marker.infoText.data.shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </p>
          <div class="text-center">
            <b-button size="sm" variant="primary" @click="emitData({...marker.infoText.data.shipping, ...{cardType: 'shipping', normalize: true}})" v-translate>
              View Detail
            </b-button>
            <b-button size="sm" variant="dark" @click="$root.$emit('Items::NavigateTo', marker.infoText.data)">
              <font-awesome-icon icon="directions" />
              <translate>Navigate To</translate>
            </b-button>
          </div>
        </div>
        <div class="text-center" v-if="!marker.infoText.data.shipping || (marker.infoText.data.shippings && marker.infoText.data.shippings.length > 0)">
          <!-- <b-button size="sm" @click="emitCreateShippingFromItem(marker.infoText.data)" v-translate>
            Create Shipping
          </b-button> -->
          <b-button size="sm" variant="dark" @click="$root.$emit('Items::NavigateTo', marker.infoText.data)">
            <font-awesome-icon icon="directions" />
            <translate>Navigate To</translate>
          </b-button>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'item-id'">
        <h3 v-if="ecosystemModules.items.label && marker.infoText.data.reference_code">
          <b-badge variant="dark">
            {{marker.infoText.data.reference_code}}
          </b-badge>
          <a href="#" @click.prevent="copyToClipboard(marker.infoText.data.reference_code)" class="text-secondary" title="Copy to Clipboard">
            <font-awesome-icon :icon="['far', 'copy']" size="1x" />
          </a>
        </h3>
        <h3 v-else-if="ecosystemModules.items.label && !marker.infoText.data.reference_code">
          {{ecosystemModules.items.label}}
        </h3>
        <h3 v-else v-translate>
          Items
        </h3>
        <dynamic-info-text :template-html="ecosystemModules.items.templateInfoText || '<div>' + $gettext('No template') + '</div>'" :marker="marker" />
        <div v-if="marker.infoText.data.shipping && marker.infoText.data.shipping.id">
          <hr>
          <p>
            <h6 v-translate>In Shipping</h6>
            <b-link :to="{name: 'ShippingsEdit', params: {id: marker.infoText.data.shipping.id}}" target="_blank">{{ marker.infoText.data.shipping.id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(marker.infoText.data.shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </p>
        </div>
      </div>

      <div v-if="marker.infoText.type === 'micro-item-id'">
        <h3 v-if="ecosystemModules.items.label && marker.infoText.data.reference_code">
          <b-badge variant="dark">
            {{marker.infoText.data.reference_code}}
          </b-badge>
        </h3>
        <h3 v-else-if="ecosystemModules.items.label && !marker.infoText.data.reference_code">
          {{ecosystemModules.items.label}}
        </h3>
        <h3 v-else v-translate>
          Items
        </h3>
        <dynamic-info-text :template-html="ecosystemModules.items.templateInfoText || '<div>' + $gettext('No template') + '</div>'" :marker="marker" />
        <div v-if="marker.infoText.data.shipping && marker.infoText.data.shipping.id">
          <hr>
          <p>
            <h6 v-translate>In Shipping</h6>
            <b-link :to="{name: 'ShippingsEdit', params: {id: marker.infoText.data.shipping.id}}" target="_blank">{{ marker.infoText.data.shipping.id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(marker.infoText.data.shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </p>
        </div>
      </div>

    </l-popup>
    <l-tooltip :content="marker.infoText" v-if="marker.tooltip" />
  </l-rotated-marker>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  LMarker,
  LTooltip,
  LPopup,
  LIcon
} from 'vue2-leaflet'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
import ShippingVisit from '@/components/Shippings/Visit'
import DynamicInfoText from '@/components/Maps/DynamicInfoText'

export default {
  name: 'MapMarker',
  components: {
    LMarker,
    LTooltip,
    LPopup,
    LIcon,
    LRotatedMarker,
    ShippingVisit,
    DynamicInfoText
  },
  props: {
    marker: {
      type: Object,
      default: () => {},
      required: true
    },
    showMarkersText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      clusterTo: null
    }
  },
  computed: {
    ...mapGetters([
      'clusters'
    ])
  },
  methods: {
    emitCourier(courier) {
      this.$emit('close-popups', true)
      this.$emit('courier-selected', courier)
    },
    emitBase(base) {
      this.$emit('close-popups', true)
      this.$emit('base-selected', base)
    },
    emitData(data) {
      this.$emit('close-popups', true)
      this.$emit('data-selected', data)
    },
    emitRemoveFromCollection(i) {
      this.$emit('item-removed', i)
    },
    emitSelectCluster(i) {
      this.$emit('cluster-selected', i)
    },
    emitMoveToCluster(id, cluster) {
      this.$emit('move-to-cluster', { id, cluster: cluster })
      this.clusterTo = null
    },
    emitMarkerOver(e) {
      this.$emit('marker-over', this.marker, e)
    },
    emitMarkerOut(e) {
      this.$emit('marker-out', this.marker, e)
    },
    emitDeleteFromTour(id) {
      this.$emit('delete-from-tour', id)
    },
    emitCreateShippingFromItem(item) {
      this.$emit('create-shipping-from-item', item)
    }
  }
}
</script>

<style lang="scss">
.leaflet-popup-content {
  margin: 0 !important;
  padding: 10px !important;
  font-size: 1em;
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  h5, h6, p {
    margin-bottom: 5px !important;
  }
}
.leaflet-container .leaflet-marker-pane img {
  width: 100% !important;
  height: 100% !important;
}
.map-tag {
  background-color: #4285F4;
  border-radius: 8px;
  font-size: 8px;
  padding: 0 4px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.icon-dynamic-mark {
  display: inline-block;
  width: 6px;
  height: 6px;
  border: 1px solid #fff;
  border-radius: 10px;
  margin-right: 1px;
}
.icon-load-mark {
  display: inline-block;
  width: 6px;
  height: 6px;
  border: 1px solid #fff;
  margin-left: 1px;
  position: relative;
  span {
    display: block;
    position: absolute;
    font-size: 11px;
    line-height: 6px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
